import React, { useState, useEffect } from "react";
import { BarLoader } from "react-spinners";

const Loader = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500/40 backdrop-blur-md">
      <div className="text-center">
        <BarLoader color="#DA3335" width={200} />
        <p className="text-primaryTextColor text-sm mt-3 tracking-wide">
          Loading, please wait...
        </p>
      </div>
    </div>
  );
};

export default Loader;
